/**
 * MessageRouterGlobal - Router for the global messages screen (/messages)
 */

import React, { useEffect } from 'react';
import { Switch, useRouteMatch, Route } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';

import { MessageListPage, MessageDetailsPage } from './components';
import { MessageProvider } from './context';
import { queryClient } from 'config/queryClient';
import { setAppTitle } from 'utils/utils';

function MessageRouterGlobal(props) {
  const { path } = useRouteMatch();

  useEffect(() => {
    setAppTitle('Messages');
    return () => setAppTitle();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <MessageProvider {...props} isGlobal>
        <Switch>
          <Route exact path={path} component={MessageListPage} />
          <Route path={`${path}/:message_id`} component={MessageDetailsPage} />
        </Switch>
      </MessageProvider>
    </QueryClientProvider>
  );
}

export default MessageRouterGlobal;
